<div class="container">
  <form *ngIf="auditDataPageGrid && auditDataPageGrid.filtersForm" #form="ngForm" [formGroup]="auditDataPageGrid.filtersForm">
    <div class="card m-b-xl m-t-xl">
      <div class="row">
        <div class="col-6 search-box m-b">
          <span>Module</span>
          <!-- <kendo-dropdownlist formControlName="modulesSelectedType" [data]="moduleTypes" [valuePrimitive]="true"
            valueField="type" textField="name" tabindex="1" [filterable]="true" (filterChange)="handleFilter($event)">
          </kendo-dropdownlist> -->
        </div>
        <div class="col-6 search-box">
          <span>Search</span>
          <input type="text" class="form-control" formControlName="searchClients" placeholder="Search" />
        </div>
      </div>
    </div>
    <div class="card">
      <kendo-grid
        class="grid-small"
        *ngIf="auditDataPageGrid && auditDataPageGrid.gridQuery.total"
        [data]="auditDataPageGrid.gridView"
        [scrollable]="'none'"
        [skip]="auditDataPageGrid.gridQuery.skip"
        [pageSize]="auditDataPageGrid.gridQuery.take"
        [sortable]="{ mode: 'single', allowUnsort: false }"
        [sort]="auditDataPageGrid.gridQuery.sort"
        (sortChange)="auditDataPageGrid.sortChange($event)"
        [pageable]="auditDataPageGrid.pagination"
        (dataStateChange)="auditDataPageGrid.gridStateChanged($event)"
      >
        <kendo-grid-column field="id" title="Id">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div style="white-space: nowrap" class="text-end">{{ dataItem.id }}</div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="activity" title="Activity">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div style="white-space: nowrap" class="text-left">{{ dataItem.type }}</div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Name" field="searchText">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div style="white-space: nowrap" class="text-left">{{ dataItem.user.firstName }} {{ dataItem.user.lastName }}</div>
            <div style="white-space: nowrap" class="text-left small" *ngIf="dataItem.user.nic">NIC : {{ dataItem.user.nic }}</div>
            <div style="white-space: nowrap" class="text-left small" *ngIf="dataItem.user.passport">
              Passport : {{ dataItem.user.passport }}
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="date" title="Date">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div style="white-space: nowrap" class="text-end">{{ dataItem.date | date : 'dd MMM yyyy hh:mm a' }}</div>
          </ng-template>
        </kendo-grid-column>

        <ng-template kendoGridNoRecordsTemplate>
          <div [hidden]="!auditDataGridInProgress" class="loader">loader</div>
        </ng-template>
      </kendo-grid>

      <div class="grid-message p-a" [hidden]="auditDataPageGrid && auditDataPageGrid.gridQuery.total">
        <p [hidden]="auditDataGridInProgress">No Records Found.</p>
      </div>
    </div>
  </form>
</div>
